import FeatureFlagProvider from './Provider';

export { default as useFeatureFlag } from './useFeatureFlag';

export default FeatureFlagProvider;
